import React from 'react';
import { QStack } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import CheckBox from '../CheckBox';

export type APICapabilitiesPermissionsFormFields = {
  canAccessAPICapabilities: boolean;
};

const APICapabilitiesPermissions = () => {
  const { t } = useTranslation();
  return (
    <QStack direction="column">
      <CheckBox
        data-cy="permission-checkbox"
        name="canAccessAPICapabilities"
        label="api capabilities"
        text={t('apiCapabilities.access')}
      />
    </QStack>
  );
};

export default APICapabilitiesPermissions;
